module.exports = __webpack_public_path__ + "img/9788994353487.bb60f41b.jpg";